// extracted by mini-css-extract-plugin
export default {"personalitySummaryWrapper":"FSHpewr3EHBIQqwZWa9A"};